module.exports = __webpack_public_path__ + "static/img/2.8a5f8dd3.jpg";